import { Link, Text, Tooltip } from '@billy/design-system'
import { useCallback } from 'react'

import { useNavigation } from '../../../../../../contexts/navigationContext'
import { OrganizationItem } from '../../../../types/organizationItem'
import * as Styled from '../../styles'

interface DropdownHeaderItemProps {
  organization: OrganizationItem
  selectedId?: string
}

export const DropdownHeaderItem = ({ organization, selectedId }: DropdownHeaderItemProps) => {
  const { isInverted, setShouldCloseDropdown } = useNavigation()

  const selectedOrganizationId = selectedId === organization.id

  const handleClickOrganizationLink = useCallback(() => {
    setShouldCloseDropdown(true)
  }, [setShouldCloseDropdown])

  const textColor = isInverted ? 'inverted' : 'primary'

  return (
    <li key={organization.id}>
      <Link href={organization.href} underlined={false} onClick={handleClickOrganizationLink}>
        <Tooltip label={organization.children} placement="left">
          <Styled.DropdownHeaderItemWrapper isSelected={selectedOrganizationId} isInverted={isInverted}>
            {organization.iconLeft}
            <Text colorVariant={textColor} truncate>
              {organization.children}
            </Text>
          </Styled.DropdownHeaderItemWrapper>
        </Tooltip>
      </Link>
    </li>
  )
}
